import React from 'react';

const ColumnsContext = React.createContext([]);

export default ColumnsContext;